export default __webpack_public_path__ + "static/article-finance-how-much-should-you-spend-when-renovating-1738981b15b7c5513d9eec81c7e965ad.webp";